import * as React from "react";
import MediaQuery from "react-responsive";

export const PCMedia : React.FC = ({children}) => {
    return (
        <>
            {/* @ts-expect-error Async Server Component */}
            <MediaQuery query={"(min-width: 768px)"}>
                {children}
            </MediaQuery>
        </>
    );
}

export const MobileMedia : React.FC = ({children}) => {
    return (
        <>
            {/* @ts-expect-error Async Server Component */}
            <MediaQuery query={"(max-width: 767px)"}>
                {children}
            </MediaQuery>
        </>
    );
}
